module.exports = __webpack_public_path__ + "img/Aura_magicorange.c6567e84.png";